import { AnimatePresence, m } from 'framer-motion';
import classNames from 'classnames';
import BrandStarSVG from '@/svg/brand-star.svg';
import Button from '@/components/shared/Button';
import { ReactNode } from 'react';

interface Props {
    children: string;
    name: string;
    value: string;
    type?: 'checkbox' | 'radio';
    bordered?: boolean;
    checked: boolean;
    onChange: (arg: boolean) => void;
    icon: ReactNode;
}

const SortingCheckbox = ({
    children,
    icon,
    name,
    value,
    type = 'checkbox',
    bordered = false,
    checked,
    onChange,
}: Props) => {
    return (
        <label
            className={classNames('sorting-checkbox m-text-xs', {
                'sorting-checkbox--checked': checked,
                'sorting-checkbox--bordered': bordered,
            })}
        >
            <Button iconReverse icon={icon} tag="span" className="sorting-checkbox__text m-text-xs">
                {bordered && <BrandStarSVG />}
                {children}
                <AnimatePresence>
                    {checked && (
                        <m.span
                            initial={{ width: 0 }}
                            exit={{ width: 0 }}
                            animate={{ width: 'auto' }}
                            className="sorting-checkbox__cross"
                            aria-hidden="true"
                        >
                            &nbsp;✓
                        </m.span>
                    )}
                </AnimatePresence>
            </Button>
            <input
                type={type}
                name={name}
                value={value}
                className="sorting-checkbox__input"
                defaultChecked={checked}
                onClick={() => {
                    onChange(!checked);
                }}
            />
        </label>
    );
};

export default SortingCheckbox;
